<template>
    <span :class="['draggable', { 'is-empty': empty }]" data-test-class="l-draggable-icon">
        <i v-if="!empty" class="fa fa-arrows color-grey-light l-draggable-icon"></i>
    </span>
</template>

<script>
export default {
    props: {
        empty: {
            type: Boolean,
            default: false,
        },
    },
    // A `data` property is needed so that this file is taken into account by jest's code coverage
    // (cf. https://github.com/vuejs/vue-jest/issues/32)
    //
    data() {
        return {};
    },
};
</script>

<style scoped>
.is-empty {
    /* To ensure the space is still held even when the icon is not visible, 
    for example in the Skills list under different filters */
    width: 14px;
}

.l-draggable-icon {
    font-size: 14px !important;
    opacity: 0.5;
}
</style>
